import { render } from "./StartPrizeDraw.vue?vue&type=template&id=10cb2bd3&scoped=true"
import script from "./StartPrizeDraw.vue?vue&type=script&lang=js"
export * from "./StartPrizeDraw.vue?vue&type=script&lang=js"

import "./StartPrizeDraw.vue?vue&type=style&index=0&id=10cb2bd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cb2bd3"]])

export default __exports__